import { useState } from "react";
import { PopupModal } from "react-calendly";
import { sz, txt, useContent } from "@/content/ContentContext";

// Live scheduling link. This is intentionally committed in code (not only stored
// in the database via the admin panel) so the booking popup can never fall back
// to a dead link after a repo import or a database reset.
export const CALENDLY_FALLBACK_URL =
  process.env.REACT_APP_CALENDLY_URL ||
  "https://calendly.com/consultations-itdeviceservices";

const BookCallButton = ({
  className = "btn-dark",
  testId = "book-call-btn",
}) => {
  const [open, setOpen] = useState(false);
  const c = useContent();
  const url = c.global.calendlyUrl || CALENDLY_FALLBACK_URL;

  return (
    <>
      <button
        type="button"
        className={className}
        style={sz(c.global.ctaLabel)}
        data-testid={testId}
        onClick={() => setOpen(true)}
      >
        {txt(c.global.ctaLabel)}
      </button>
      <PopupModal
        url={url}
        open={open}
        onModalClose={() => setOpen(false)}
        rootElement={document.getElementById("root")}
      />
    </>
  );
};

export default BookCallButton;
